import { Routes } from '@angular/router';
import { MigrationsMainComponent } from './containers/migrations-main/migrations-main.component';
import { MigrationsAccountDetailComponent } from './containers/migrations-account-detail/migrations-account-detail.component';

export const MIGRATIONS_ROUTES: Routes = [
  {
    path: '',
    component: MigrationsMainComponent,
  },
  {
    path: ':accountId/:proAccountId',
    component: MigrationsAccountDetailComponent,
  },
];
